<template>
	<div class="btn-wrapper"
		:style="`background-color:${$appColors.white};border-color:${$appColors.gray}`"
	>
		<v-btn type="button"
			class="poll-btn"
			:style="`background-color:${$appColors.primary};color:${$appColors.white}!important`"
			@click="createPoll"
			:disabled="disabled"
		>
			Enviar Estudio
		</v-btn>
	</div>
</template>
<script>
function createPoll() {
	this.$emit('create');
}

export default {
	name: 'send-poll-btn',
	methods: {
		createPoll,
	},
	props: {
		disabled: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss" scoped>

	.btn-wrapper {
		@include flex-center;
		border-bottom: 1px solid;
		border-top: 1px solid;
		bottom: 0;
		height: 72px;
		left: 0;
		padding-left: 70px;
		position: fixed;
		width: 100%;

		@media (max-width: 768px) {
			padding-left: 0px;
		}
	}
	.poll-btn {
		border-radius: 18.5px;
		box-shadow: none !important;
		font-family: font(bold);
		height: 37px;
		text-transform: none;
		width: 156px 
	}
</style>




// WEBPACK FOOTER //
// src/components/polls/send-poll-btn.vue